import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
// Components
import BlogContent from '../../components/BlogContent/BlogContent';
import { dynamicBlogValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

import s from './blog.css';

const Blog = (props) => {
    const { data, intl: { locale } } = props;
    const dynamicData = dynamicBlogValue(data, locale);
    const initialValues = { ...data, ...dynamicData };

    return (
        <div>
            <BlogContent initialValues={initialValues} />
        </div>
    );
}

Blog.propTypes = {
    title: PropTypes.string.isRequired
};

export default injectIntl(withStyles(s)(Blog));
